export default {
  /**
   * jsImport
   *
   * @param {string} url The url to resolve
   *
   * @description
   * Load external script(s) and return a promise
   */
  url(url, forceNewLoad) {
    window.remus_import_scripts = window.remus_import_scripts || [];
    return new Promise((resolve, reject) => {
      let scriptEl = document.querySelector('script[src="' + url + '"]');
      let loadedIndex = window.remus_import_scripts.indexOf(url);
      if (forceNewLoad) {
        if (scriptEl) scriptEl.remove();
        scriptEl = undefined;
        if (loadedIndex !== -1) window.remus_import_scripts.splice(loadedIndex, 1);
      }
      if (!scriptEl && !window.remus_import_scripts.includes(url)) {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.addEventListener('load', () => {
          /*eslint-disable */
          console.log('loaded script: ' + url);
          /*eslint-enable */
          window.remus_import_scripts.push(url);
          resolve(script)
        }, false);
        script.addEventListener('error', () => reject(script), false);
        document.body.appendChild(script);
      } else if (scriptEl && loadedIndex === -1) {
        scriptEl.addEventListener('load', () => {
          /*eslint-disable */
          console.log('additional loaded script: ' + url);
          /*eslint-enable */
          resolve(scriptEl)
        }, false)
      } else {
        resolve(scriptEl)
      }
    });
  },
  urls(urls, forceNewLoad) {
    return Promise.all(urls.map(url => {return this.url(url, forceNewLoad)}));
  },
}



// WEBPACK FOOTER //
// ./scripts/util/js-import.js